var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExportIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 32,
    viewBox: "0 0 30 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.875 7.06699C6.875 6.22691 6.875 5.80687 7.03849 5.48601C7.1823 5.20376 7.41177 4.97429 7.69401 4.83048C8.01488 4.66699 8.43492 4.66699 9.275 4.66699H15.8352C16.2184 4.66699 16.4101 4.66699 16.5894 4.71189C16.7484 4.75169 16.8998 4.81728 17.0376 4.90605C17.193 5.00619 17.324 5.14597 17.5861 5.42553L22.4759 10.6413C22.7158 10.8971 22.8357 11.0251 22.9213 11.1721C22.9973 11.3026 23.0531 11.4437 23.0869 11.5908C23.125 11.7566 23.125 11.932 23.125 12.2827V24.9337C23.125 25.7737 23.125 26.1938 22.9615 26.5146C22.8177 26.7969 22.5882 27.0264 22.306 27.1702C21.9851 27.3337 21.5651 27.3337 20.725 27.3337H9.275C8.43492 27.3337 8.01488 27.3337 7.69401 27.1702C7.41177 27.0264 7.1823 26.7969 7.03849 26.5146C6.875 26.1938 6.875 25.7737 6.875 24.9337V7.06699Z",
    stroke: "#575757"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.625 4.66699V10.267C15.625 11.1071 15.625 11.5271 15.7885 11.848C15.9323 12.1302 16.1618 12.3597 16.444 12.5035C16.7649 12.667 17.1849 12.667 18.025 12.667H23.125",
    stroke: "#575757"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9675 20.0268L27.6472 22.5106M27.6472 22.5106L26.0159 25.0265M27.6472 22.5106L21.0251 22.5747",
    stroke: "#575757",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportIcon);
export default __webpack_public_path__ + "static/media/export-icon.43ea202ea5b93332d70d7a99ed9640da.svg";
export { ForwardRef as ReactComponent };